module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/cate',
        query: {
          id: 113
        }
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 艺术节")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "error"
    }
  }, [_vm._v("\n      1.请先登陆单位会员帐号或注册（注意只对机构单位会员，个人会员无法报名）"), _c('br'), _vm._v("\n      2.请您确保在整个申报流程中，您所填写的信息属实。"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_center"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "apply_info_title"
  }, [_vm._v("申报信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "场次"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.formData.saiqu_name) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位名称",
      "prop": "danwei"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "表演类型",
      "prop": "subject"
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.subject_options,
      "placeholder": "请选择组别"
    },
    model: {
      value: (_vm.formData.subject),
      callback: function($$v) {
        _vm.$set(_vm.formData, "subject", $$v)
      },
      expression: "formData.subject"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "级别",
      "prop": "group_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.group_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "group_id", $$v)
      },
      expression: "formData.group_id"
    }
  }, _vm._l((_vm.group_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市",
      "prop": "areas"
    }
  }, [_c('el-cascader', {
    staticClass: "inputSizeClass",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    model: {
      value: (_vm.formData.areas),
      callback: function($$v) {
        _vm.$set(_vm.formData, "areas", $$v)
      },
      expression: "formData.areas"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人姓名",
      "prop": "ldname"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.ldname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ldname", $$v)
      },
      expression: "formData.ldname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系手机",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "特殊诉求",
      "prop": "note"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "本次团队活动是否需要增加民族餐？病人餐或宵夜？是否需要残疾椅租赁车辆？是否需要大床房或亲子房？是否有外宾等，请如实填写。"
    },
    model: {
      value: (_vm.formData.note),
      callback: function($$v) {
        _vm.$set(_vm.formData, "note", $$v)
      },
      expression: "formData.note"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.id > 0),
      expression: "formData.id > 0"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "服务套餐",
      "prop": "note"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.trip_ids),
      callback: function($$v) {
        _vm.$set(_vm.formData, "trip_ids", $$v)
      },
      expression: "formData.trip_ids"
    }
  }, _vm._l((_vm.trip_options), function(service, sindex) {
    return _c('el-option', {
      key: sindex,
      attrs: {
        "label": service.name +
          '(' +
          service.price +
          '元/' +
          (service.price_type == 1 ? '次' : '人') +
          ')' +
          service.days +
          '天',
        "value": service.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.id > 0 && _vm.userListForm.list.length > 0),
      expression: "formData.id > 0 && userListForm.list.length > 0"
    }],
    staticClass: "apply_info_title"
  }, [_vm._v("\n            费用信息\n          ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.id > 0 && _vm.userListForm.list.length > 0),
      expression: "formData.id > 0 && userListForm.list.length > 0"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "天数"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.total_days) + "\n              ")])], 1), _vm._v(" "), (false) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.end_date && _vm.total_days),
      expression: "end_date && total_days"
    }],
    attrs: {
      "label": "日期"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.formData.get_date) + " 至 " + _vm._s(_vm.end_date) + "\n              ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.id > 0 && _vm.userListForm.list.length > 0),
      expression: "formData.id > 0 && userListForm.list.length > 0"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人数统计"
    }
  }, [_vm._v("\n                总计：" + _vm._s(_vm.member.total) + " （男" + _vm._s(_vm.member.m) + "，女" + _vm._s(_vm.member.f) + "）\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "费用"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.price.total) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.id > 0),
      expression: "formData.id > 0"
    }]
  }, [_c('el-form', {
    ref: "userListForm",
    attrs: {
      "rules": _vm.userListForm.rules,
      "model": _vm.userListForm
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userListForm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.name) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.name',
            "rules": _vm.userListForm.rules.name
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入姓名"
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "身份证",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.num) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.num',
            "rules": _vm.userListForm.rules.num
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入身份证号"
          },
          model: {
            value: (scope.row.num),
            callback: function($$v) {
              _vm.$set(scope.row, "num", $$v)
            },
            expression: "scope.row.num"
          }
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.sex) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.sex',
            "rules": _vm.userListForm.rules.sex
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.sex),
            callback: function($$v) {
              _vm.$set(scope.row, "sex", $$v)
            },
            expression: "scope.row.sex"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "男",
            "value": "男"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "女",
            "value": "女"
          }
        })], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(_vm._f("typeName")(scope.row.type)) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.type',
            "rules": _vm.userListForm.rules.type
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.type),
            callback: function($$v) {
              _vm.$set(scope.row, "type", $$v)
            },
            expression: "scope.row.type"
          }
        }, _vm._l((_vm.member_type_list), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.phone) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.phone',
            "rules": _vm.userListForm.rules.phone
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入手机号"
          },
          model: {
            value: (scope.row.phone),
            callback: function($$v) {
              _vm.$set(scope.row, "phone", $$v)
            },
            expression: "scope.row.phone"
          }
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "服务套餐"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.service_name) + " (" + _vm._s(scope.row.service_price) + "元)\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.service_id',
            "rules": _vm.userListForm.rules.service_id
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              return _vm.onServiceChange($event, scope.row)
            }
          },
          model: {
            value: (scope.row.service_id),
            callback: function($$v) {
              _vm.$set(scope.row, "service_id", $$v)
            },
            expression: "scope.row.service_id"
          }
        }, _vm._l((_vm.service_options), function(service, sindex) {
          return _c('el-option', {
            key: sindex,
            attrs: {
              "label": service.name + '(' + service.price + '元)',
              "value": service.id
            }
          })
        }), 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.onUserEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-popconfirm', {
          attrs: {
            "title": "这是一段内容确定删除吗？"
          },
          on: {
            "confirm": function($event) {
              return _vm.onUserRemove(scope.row, scope.$index)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("删除")])], 1)], 1) : _c('p', [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.onUserSave(scope.row)
            }
          }
        }, [_vm._v("保存")]), _vm._v(" "), _c('el-popconfirm', {
          attrs: {
            "title": "这是一段内容确定删除吗？"
          },
          on: {
            "confirm": function($event) {
              return _vm.onUserRemove(scope.row, scope.$index)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("删除")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.onUserAdd()
      }
    }
  }, [_vm._v("新增用户")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "btn_position_class"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('ElPayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "scene": "yishujie",
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  }), _vm._v(" "), _c('OrderDetailDialog', {
    attrs: {
      "fieldArr": _vm.fieldArr,
      "memberArr": _vm.memberArr,
      "dialogShow": _vm.orderDetailDialogShow
    },
    on: {
      "orderDetailDialogConfirm": _vm.orderDetailDialogConfirm,
      "orderDetailDialogCancel": _vm.orderDetailDialogCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72b83928","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/yishujie/YishujieApplyStep1.vue
// module id = 1281
// module chunks = 0